import React from 'react'
import Loading from '../Loading'
import jobRepo from '../../requests/jobs'
import { Chart } from 'react-google-charts'
import WidgetHeader from './WidgetHeader'
export default class ServerByAvgLoad extends React.Component {
  constructor(props, context) {
    super(props, context);
    this.state = {
      loading: false,
      time: 0,
      options: {
        // title: 'Box Office Earnings in First Two Weeks of Opening',
        // subtitle: 'in millions of dollars (USD)',
        // hAxis: { title: 'Age', minValue: 0, maxValue: 15 },
        // vAxis: { title: 'Weight', minValue: 0, maxValue: 15 },
        legend: 'none',
      },
      data: [
        ['date', 'sever1', 'server2', 'server3'],
        ['Dic 1', 2,  30.9, 69.5],
        ['Dic 2', 3,  25.4,   57],
        ['Dic 3', 4,  11.7, 18.8],
        ['Dic 5', 5,  11.9, 17.6],
        ['Dic 6', 6,   8.8, 13.6],
        ['Dic 7', 7,   7.6, 12.3],
        ['Dic 8', 8,  12.3, 29.2]
      ]
      // rows: [
      //   ['',  0, 0],
      //   // [2,  30.9, 69.5],
      //   // [3,  25.4,   57],
      //   // [4,  11.7, 18.8],
      //   // [5,  11.9, 17.6],
      //   // [6,   8.8, 13.6],
      //   // [7,   7.6, 12.3],
      //   // [8,  12.3, 29.2],
      //   // [9,  16.9, 42.9],
      //   // [10, 12.8, 30.9],
      //   // [11,  5.3,  7.9],
      //   // [12,  6.6,  8.4],
      //   // [13,  4.8,  6.3],
      //   // [14,  4.2,  6.2]
      // ],
      // columns: [
      //   {
      //     type: 'string',
      //     label: 'Day',
      //   },
      //   {
      //     type: 'number',
      //     label: 'Done'
      //   },
      //   {
      //     type: 'number',
      //     label: 'Error'
      //   }
      // ]
    }
  }
  componentWillMount () {
    if(!this.props.time || !this.state.time){
      this.setState({time: '24'})
    }
    // this.loadData()
  }
  loadData() {
    // this.setState({loading: true})
    jobRepo.getJobCounterByStatusGroupByDate(this.state.time).then(data => {
      console.log(data)
      this.setState({ rows: data, loading: false})
    })
  }
  async onTimeChange(time){
    await this.setState({time})
    // this.loadData()
  }
  render(){
    if(this.state.loading === true){
      return(<Loading/>)
    }
    const time_opt = [
      { value: '12', label: 'Last 12 Hours' },
      { value: '24', label: 'Last 24 Hours' },
      { value: `${2 * 24}`, label: 'Last 2 Days' },
      { value: `${5 * 24}`, label: 'Last 5 Days' },
      { value: `${7 * 24}`, label: 'Last Week' }
    ]
    console.log('en server', this.state.time)
    return(
      <div>
      <WidgetHeader title = 'By Load Average' options={time_opt} time={this.state.time} onChange={(time) =>{this.onTimeChange(time)}}/>
      <div className={'col-md-12'}>
        <Chart
          chartType="Line"
          // rows={this.state.rows}
          // columns={this.state.columns}
          data={this.state.data}
          options={this.state.options}
          graph_id="Line-ServerByAvgLoad"
          width={'100%'}
          height={'300px'}
          legend_toggle
        />
      </div>
      </div>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/dashboard/ServerByAvgLoad.js